import { faArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowDown'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH'
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock'
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faStarHalf } from '@fortawesome/pro-solid-svg-icons/faStarHalf'
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers'
import { faExternalLinkSquare } from '@fortawesome/pro-solid-svg-icons/faExternalLinkSquare'

export default [
  faArrowDown,
  faCheckCircle,
  faEllipsisH,
  faLock,
  faPaperPlane,
  faCaretDown,
  faStar,
  faStarHalf,
  faUsers,
  faExternalLinkSquare
]
